module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_005#uGBpnHjg5jW3h2kOLn4OZI6"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_006#uqcsJvP5ctR6xandoEefywE"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_007#usLg6hKcbbUUIDbV3IudHo7"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_008#uDUaAgTruGTAgwHFzkzywHD"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_009#uBllYYJhbAWnWHxbDCVCgS5"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_010#uRD3MrE54WLlNoOcGd6GtQH"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_011#u5uWpUD7u6lYc4hFad6YVT5"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_012#ujvgEprC4p58gR94CUnykh6"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_013#uLX4zhELdFTeSkkhqPhP9BC"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_014#uknryNVUUIQUhv46IDk2TAD"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_015#uoLxjgMkc4QA9DVCzkVhLj2"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_016#uo2iLHSmDrmpazJ5JEgQBhD"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_017#uWCBDg3H2v3AiA6dC8J3QzG"
    }
  }, [_vm._v("CHAPTER TWELVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_018#ueQsIG3CYFbZoGlJ8jhAwU4"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_019#uDfafLSEBPrPLKzxfCtkBDG"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NA_020#up9G6yqa76FDOf2p9gTigm5"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_021#uJ2tHlTJG2BWIN2cjV9TYoC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_022#uehKF7fB7BxYRvtG4t2dMLH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_023#u5i5XSxZUuvXmZqyz8qtlq3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_024#uzo6sOyPwq3uAxdvND53Sg4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_025#utdgxtE5JoqNPA5NaMGn386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_026#uUxrTtHOGntHuprYlMt2zeE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_027#uXnzL9XFAyWF3NHa5CMcZyE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_028#uvch6X6yimaPaxuhnrGdMf9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_029#ukQu7wiac5GOttgDquWbofA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_030#uCZdkoZlmZbN4efrtAXEJFF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FIVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_031#u6S2DZSPgzstNC8dexopNbC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-SIX")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_032#uxS6uFxAMegLhrkzyrslG5G",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-SEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_033_split_000#uupIrueepYJjvhOH5D29xs8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photos")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_034#usSnstHGNLY3ZIchPEdnjAF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-EIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_035#uhFOZkhLfOwEKcctexiorn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-NINE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_036#uH6tO4nTb8k4DW5dv6lE6jD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_037#ulbmdcsgBHs5EQZISfVDuo6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY-ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_038#uPPjdqavv24k9zI2E4TCmRH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY-TWO")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_039#uFeVCwEnbQz3bq7OMZCkfK4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY-THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_040#uR48SPtfvg8LqapJvAb4FOH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY-FOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_041#u9XeqgTktEslXIW2nbTbPh2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY-FIVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_042#ubT27UKpzWDeQH8nYgb2U6B",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY-SIX")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_043#ulIcDECdNx7mEq7x39pDCU4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY-SEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_044#uxFfeiCoxxOr8lILsUPW2m4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTY-EIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_045#urs2eE6hhoMPuH2SWvrPTAD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRY-NINE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_046#uRWmyyyalw6QbFUmjYyaIFB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_047#uwP7hRDv56eBCf8dNWeHeW2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_048#ufUBTahePEVFu8mL3GyViE9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-TWO")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_049#uBcd7jh5tOKYuXVIcvdLT4B",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_050#uf55jzMPhyZ7YCJk4TuZcFF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-FOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_051#usMtMGpyH8MhKlwaynRCz35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-FIVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_052#ucvkk2D5s5kvDnM34LRHJcC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-SIX")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_053#ubW2StRqkQ9bAV6vVK3kOl5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-SEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_054#u79TDtNIx2dvyVR2eJum5e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-EIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_055#u29BHbiaRKCrhzAkE5k69X9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FORTY-NINE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_056#u6b2t4O7tPAbwvUkJIzlC95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_057#usNyOjoUt9E99fLhufI87fF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY-ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_058#u7FS2mqQSkLXiNot3erJIx3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY-TWO")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_059#umkIBWhmFLfFX3qWn6NVUb9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY-THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_060#uCrNxVspqWUSkobHur89Xx2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY-FOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_061#uG2ru5S6NKAjJDU9vtEBKeE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY-FIVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_062#uEDkFoPXNcDOHtkQnyGhaK4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY-SIX")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_063#um3VBTaEavSGciSq2BTrhR2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY-SEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_064#uum3X7QnithFzamUblCvjw8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTY-EIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NA_065#uUKiib2xTRNXxaD6jucrwD4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FROM THE AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4780c9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/NA_004_toc.vue
// module id = 78
// module chunks = 0